import Footer from "../Component/Footer";
import Header from "../Component/Header";
import { useCallback, useEffect, useState } from "react";
import ProjectList from "../Component/ProjectList";
import ProjectModal from "../Component/ProjectModal";

function Work() {
  const [projects, setProjects] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const populateData = useCallback(() => {
    setProjects([
      {
        title: "Pusaka Suwung",
        description:
          "This game is having singleplayer, horror, and puzzle genres. Player must solve a puzzle in order to escape. Also the Java themed is make this horror game pretty scary. ",
        category: ["Game", "Unity"],
        url: "https://kreasaka.itch.io/pusaka-suwung/",
        image: ["/images/LogoPusakaSuwung.png", ""],
      },
      {
        title: "FloWise",
        description:
          "This mobile application is used to track user money both income and expense. User can easily write down transaction that user have done. Also there is report feature to know how the user manage their money for some time period. ",
        category: ["Mobile", "Android Studio", "Laravel"],
        url: "",
        image: ["/images/LogoFloWise.png", ""],
      },
      {
        title: "Recruit Management",
        description:
          "This web application is used to giving a space for people to either recruiting an employee or applying for a job. User can easily fill up their information detail as well as seeing their recruitment status. ",
        category: ["Website", "React", "Laravel"],
        url: "",
        image: ["/images/LogoRecruitManagement.svg", ""],
      },
    ]);
  }, []);

  useEffect(() => {
    populateData();
  }, [populateData]);

  const openModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  return (
    <div>
      <Header />
      <section className="bg-lightGray py-16 sm:py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12 sm:text-4xl">
          My Latest <span className="text-crimson">Projects</span>
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects && projects.map((item, index) => (
            <ProjectList
              key={index} 
              item={item} 
              onViewDetails={() => openModal(item)} 
            />
          ))}
        </div>
      </div>

      {selectedProject && (
        <ProjectModal
          isOpen={isModalOpen} 
          onClose={closeModal} 
          project={selectedProject} 
        />
      )}
    </section>
      <Footer />
    </div>
  );
}

export default Work;
